import React from "react"
import { BrowserRouter } from 'react-router-dom';
import Routers from "./Routes/Routers";
import { setToken } from "./token/store";
import { config } from "./config/api";


function App() {
  let qs = new URLSearchParams(window.location.search)
  const token = qs.get('token');
  const payload = qs.get('payload');
  const id = qs.get('id');

  if (token !== null) {
    setToken(token)
  }
  if (payload !== null) {
    window.history.replaceState(null, '', '/orders?payload=' + payload)
  } 
  if(id !== null){
    window.history.replaceState(null, '', '?id=' + id)

  } else{
    window.history.replaceState(null, '', window.location.pathname)
  }

  config()

  return (
    <BrowserRouter>
      <Routers />
    </BrowserRouter>
  );
}


export default App;